import React from "react";

export const CANVAS_SIZE = 1080;

export const DEFAULT_HEADSHOT = { src: null, zoom: 1, x: 0, y: 0 };

export const DEFAULT_DATA = {
  name: "",
  role: "",
  team: "",
  tagline: "Welcome to the family",
  note: "Glad you're here!",
};

export function firstNameOf(name) {
  return (name || "").trim().split(/\s+/)[0] || "";
}

/**
 * Photo frame shared by every template. The frame decides the shape/size via
 * className + style; the image inside always covers the frame and is offset by
 * the user's pan (x/y as % of the frame) and zoom.
 */
export function Headshot({ headshot, className = "", style }) {
  const { src, zoom = 1, x = 0, y = 0 } = headshot || DEFAULT_HEADSHOT;
  return (
    <div className={`wp-headshot ${src ? "" : "wp-headshot--empty"} ${className}`} style={style}>
      {src ? (
        <img
          src={src}
          alt=""
          draggable={false}
          style={{ transform: `translate(${x}%, ${y}%) scale(${zoom})` }}
        />
      ) : (
        <div className="wp-headshot__placeholder">
          <svg viewBox="0 0 24 24" width="38%" height="38%" fill="none" stroke="currentColor" strokeWidth="1.2">
            <circle cx="12" cy="8" r="4" />
            <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" />
          </svg>
        </div>
      )}
    </div>
  );
}

/** Small line icons used in the editorial footer strip. */
export const Icons = {
  People: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" {...props}>
      <circle cx="9" cy="8" r="3" />
      <circle cx="17" cy="9" r="2.4" />
      <path d="M3 19c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" />
      <path d="M15.5 14.2c2.8.2 5.5 2 5.5 4.8" />
    </svg>
  ),
  Bulb: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" {...props}>
      <path d="M9 18h6" />
      <path d="M10 21h4" />
      <path d="M8.5 14.5C7 13.3 6 11.7 6 9.8 6 6.6 8.7 4 12 4s6 2.6 6 5.8c0 1.9-1 3.5-2.5 4.7-.5.4-.5 1-.5 1.5V17H9v-1c0-.5 0-1.1-.5-1.5z" />
    </svg>
  ),
  Chart: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" {...props}>
      <path d="M4 20h16" />
      <rect x="5" y="12" width="3.5" height="8" />
      <rect x="10.25" y="7" width="3.5" height="13" />
      <rect x="15.5" y="10" width="3.5" height="10" />
    </svg>
  ),
  Sprout: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" {...props}>
      <path d="M12 21v-8" />
      <path d="M12 13c0-3.5-2.5-6-6-6 0 3.5 2.5 6 6 6z" />
      <path d="M12 11c0-3.5 2.5-6 6-6 0 3.5-2.5 6-6 6z" />
      <path d="M7 21h10" />
    </svg>
  ),
};

export const VALUES = [
  { icon: "People", label: ["Real", "conversations"] },
  { icon: "Bulb", label: ["Fresh", "ideas"] },
  { icon: "Chart", label: ["Bigger", "opportunities"] },
  { icon: "Sprout", label: ["Together", "we ignite"] },
];
